<template>
    <SystemDiagram :system="system" :full-width="fullWidth" class="system--micro">
        <template v-slot:diagram="{ inverter, mppts, activeMppt, setActive }">
            <div class="id-inverter" @click="setActive(0)">
                <img src="/dist/images/job/inverter.svg" alt="">
                <p class="id-inverter-title small semi">{{ inverter.$model.model }}</p>
            </div>

            <SystemMpptMicro
                v-for="(mppt, mpptIndex) in limitMppts(mppts.$each.$iter)"
                :id="mppt.$model.id"
                :key="mpptIndex"
                :index="mpptIndex"
                :inverter-qty="mppt.$model.parallel"
                :panels-per-inverter="mppt.$model.series"
                :panel="mppt.$model.panel"
                :active="activeMppt === mppt"
                :valid="!mppt.$invalid"
                @activated="setActive(mppt.$model.id)"
            />
        </template>

        <template v-slot:fields="{ activeMppt, inverter }">
            <slot :activeMppt="activeMppt" :inverter="inverter">
                <div :key="activeMppt.$model.id" class="fields">
                    <FieldSelect
                        v-model="activeMppt.$model.panel"
                        :options="panelOptions"
                        class="white-theme field--full"
                        label="Panel Type"
                        placeholder="Select panel"
                        :select-options="{ getOptionLabel: createPanelLabel }"
                    />

                    <FieldSlider
                        v-model="activeMppt.$model.parallel"
                        :range="{ min: 1, max: 100 }"
                        class="white-theme"
                        label="Inverters in system"
                    />

                    <FieldSlider
                        v-model="activeMppt.$model.series"
                        :range="{ min: 1, max: 100 }"
                        class="white-theme"
                        label="Number of panels per inverter"
                    />
                </div>
            </slot>
        </template>
    </SystemDiagram>
</template>

<script>
import SystemDiagram from "@/jobs/new/SystemDiagram";
import SystemMpptMicro from "@/jobs/new/SystemMpptMicro";
import FieldSelect from '@/form/Select';
import FieldSlider from '@/form/Slider';

export default {
    components: {
        SystemDiagram,
        SystemMpptMicro,
        FieldSelect,
        FieldSlider
    },

    props: {
        index: {
            type: [Number, String],
            default: null
        },
        system: {
            type: Object,
            required: true
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        panelOptions: {
            type: Array,
            default: () => []
        },
        startMppt: {
            type: Number,
            default: 0
        },
        mpptsPerDiagram: {
            type: Number,
            default: 1
        }
    },

    computed: {
        parsedIndex() {
            return parseInt(this.index) + 1;
        }
    },

    methods: {
        createPanelLabel(option) {
            return `${option.manufacturer} - ${option.model}`;
        },

        limitMppts(mppts) {
            const arr = Object.entries(mppts).map((mppt) => mppt[1]);
            return arr.slice(this.startMppt, this.startMppt + this.mpptsPerDiagram);
        }
    }
}
</script>

<style lang="scss" scoped>
    .id-inverter {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;

        img {
            margin-bottom: 0.5em;
        }
    }

    .id-inverter-title {
        word-break: break-word;
        width: 135px;
    }
</style>
